module.exports = __webpack_public_path__ + "static/media/lana-del-rey.b8b30314.jpg";